/**
 * AnnouncementBar component
 * Measures the height of the announcement bar and sets a CSS variable to be used for header positioning
 */
export default class AnnouncementBar {
  constructor() {
    this.announcementBar = document.querySelector('.announcement-bar');
    
    if (!this.announcementBar) return;
    
    this.init();
    this.setupResizeObserver();
  }

  init() {
    this.setAnnouncementBarHeight();
  }

  /**
   * Sets a CSS variable with the height of the announcement bar
   */
  setAnnouncementBarHeight() {
    if (!this.announcementBar) return;
    
    const height = this.announcementBar.offsetHeight;
    document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
  }

  /**
   * Sets up a resize observer to update the height when the announcement bar changes size
   * This handles cases where the text wraps to multiple lines
   */
  setupResizeObserver() {
    if (!this.announcementBar || !window.ResizeObserver) return;
    
    const resizeObserver = new ResizeObserver(() => {
      this.setAnnouncementBarHeight();
    });
    
    resizeObserver.observe(this.announcementBar);
  }
} 